module.exports = __webpack_public_path__ + "static/media/ris-r.67be084a.mp3";